module.exports = __webpack_public_path__ + "media/SD_ALERT_24.000a53f3.mp3";